const getToken = () => {
    return JSON.parse(localStorage.getItem("key"));
};
const getUserId = () => {
  return Number(localStorage.getItem("userId"));
};
const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};
export const setUserSkill = (value, checked) => async (dispatch) => {
  dispatch({
      type: "SET_CHECKED",
      payload: value,
  });
};
export const unsetUserSkill = (value, checked) => async (dispatch) => {
  dispatch({
      type: "SET_UNCHECKED",
      payload: value,
  });
};
export const getUserGroupSkill = (GroupID) => async (dispatch) => {
 
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/group/user/skill/SearchGroupSkill/${GroupID}`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch({
        type: "GET_USER_GROUPS",
        payload: data,
      });
    });
};
export const setSearchByGroupId = (state) => async (dispatch) => {
    dispatch({
      type: "SET_SEARCH_GROUP_ID",
      payload: state,
    });
};
export const setSearchByDeptName = (state) => async (dispatch) => {
    dispatch({
      type: "SET_SEARCH_DEPT_NAME",
      payload: state,
    });
  };